<template>
  <div class="special-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :inline="true">
        <FormItem>
          <Button @click="showDraw()"
                  type="success"
                  class="f-r">添加专题</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showDrawStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="search"
            ref="specialValidate"
            :rules="specialValidate">
        <FormItem label="标题"
                  label-position="top"
                  prop="name">
          <Input v-model="search.name"></Input>
        </FormItem>
        <FormItem label="描述"
                  label-position="top"
                  prop="describe">
          <Input type="textarea"
                 v-model="search.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="缩略图">
          <upload-thumb v-model="search.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="320"
                        :autoCropHeight="450"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif"></upload-thumb>
        </FormItem>
        <FormItem label="背景图">
          <upload-thumb v-model="search.background_img"
                        ref="uploadthumbTwo"
                        :defaultList="thumblistTwo"
                        :autoCropWidth="750"
                        :autoCropHeight="570"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif"></upload-thumb>
        </FormItem>
        <FormItem label="请选择匠人">
          <Select v-model="tablelist1"
                  multiple
                  filterable>
            <Option v-for="item in list"
                    :value="item.id"
                    :key="item.id">{{ item.nickname }}</Option>
          </Select>
        </FormItem>
        <FormItem label="排序"
                  label-position="top">
          <Input v-model="search.sort"></Input>
        </FormItem>
        <FormItem label="状态"
                  label-position="top">
          <RadioGroup v-model="search.status">
            <Radio label="0">正常</Radio>
            <Radio label="1">禁用</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showDrawStatus = false">取消</Button>
        <Button type="primary"
                @click="createHot('specialValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";

export default {
  name: "special-list",
  data () {
    return {
      title: "添加专题",
      loading: true,
      dataloading: true,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      search_s: {
        //专题商品等
        key: ""
      },
      columns: [
        {
          title: "排序",
          key: "sort",
          width: 100,
          fixed: "left"
        },
        {
          title: "Id",
          key: "id",
          width: 100
        },
        {
          title: "专题名称",
          key: "name",
          width: 100
        },
        {
          title: "缩略图",
          key: "thumb",
          width: 100,
          render: (h, params) => {
            const zUrl = "https://images.weserv.nl/?url=";
            let thumbImg =
              this.$publicData.ossUrl + params.row.thumb;
            return h("div", [
              h(
                "Avatar",
                {
                  props: {
                    src: thumbImg
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: "简介",
          key: "describe",
          minWidth: 100
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            return h("div", params.row.status == "0" ? "正常" : "禁用");
          }
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.tradlist(params.row.id);
                    }
                  }
                },
                "匠人列表"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      columns1: [
        {
          title: "匠人名称",
          key: "nickname",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeTra(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      columns2: [
        {
          type: "selection",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "nickname",
          fixed: "left"
        }
      ],
      tablelist: [],
      tablelist1: [],
      thumblist: [],
      thumblistTwo: [],
      list: [],
      type: "1", //专题类型1商品2约看
      search: {
        name: "",
        sort: 0,
        status: "0",
        tradesman_id: ""
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      pages1: {
        page: 1,
        size: 99999,
        total: 0
      },
      showDrawStatus: false,
      showModalStatus: false,
      specialValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }],
        describe: [{ required: true, message: "描述必须填写", trigger: "blur" }]
      }
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
    this.getList();
  },
  components: {
    UploadThumb
  },
  methods: {
    getTableList: function () {
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.special.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showDraw () {
      this.search = {
        name: "",
        describe: "",
        sort: 0,
        status: "0"
      };
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.tablelist1 = [];
      this.showDrawStatus = !this.showDrawStatus;
      this.getList();
    },
    getList: function () {
      var ps = {
        page: this.pages1.page,
        size: this.pages1.size
      };
      this.$api.tradesman.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.list = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },

    //展开选择
    showModel () {
      // this.search={
      //     name:'',
      //     describe: '',
      //     sort:0,
      //     status:"0",
      // };
      // this.thumblist = new Array();
      // this.tablelist1 = [];
      this.showModalStatus = true;
    },
    // 详情
    detail (id) {
      this.title = "修改专题";
      this.search.id = id;
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.$refs["specialValidate"].resetFields();
      this.showDrawStatus = !this.showDrawStatus;
      this.$api.special.detail({ special_id: id }).then(res => {
        this.search = res.result.special;
        if (this.search.thumb != null && this.search.thumb != "") {
          this.thumblist.push({
            name: this.search.thumb,
            url: this.search.thumb,
            status: "finished"
          });
          if (
            this.search.background_img != null &&
            this.search.background_img != ""
          ) {
            this.thumblistTwo.push({
              name: this.search.background_img,
              url: this.search.background_img,
              status: "finished"
            });
          }
        }
        this.search.status = res.result.special.status.toString();
        this.tablelist1 = [];
        for (let i = 0; i < res.result.trad.length; i++) {
          const trad = res.result.trad[i];
          this.tablelist1.push(trad.id);
        }
      });
    },
    tradlist: function (id) {
      this.$router.push(`/specialtrad/list/${id}`);
    },
    // 添加
    createHot (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.search.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          }
          if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
            this.search.background_img = this.$refs[
              "uploadthumbTwo"
            ].uploadList[0].url;
          }
          var tb = "";
          for (var i in this.tablelist1) {
            tb += this.tablelist1[i] + ",";
          }
          this.search.tradesman_id = tb;
          if (this.search.id == null || this.search.id == 0) {
            this.$api.special.create({ data: this.search }).then(res => {
              if (res.code == 200) {
                this.showDrawStatus = !this.showDrawStatus;
                this.search.name = "";
                this.getTableList();
              }
            });
          } else {
            this.$api.special.edit({ data: this.search }).then(res => {
              if (res.code == 200) {
                this.showDrawStatus = !this.showDrawStatus;
                this.search.name = "";
                this.getTableList();
              }
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.special.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    removeTra: function (index, id) {
      this.tablelist1.splice(index, 1);
      // 弹出确认框
      // this.$Modal.confirm({
      //     title: '警告',
      //     content: '<p>此操作不可恢复，三思而后行...</p>',
      //     onOk: () => {
      //         if (this.search.id == null || this.search.id == 0) {
      //             //删除这一条展示
      //         } else {
      //             this.$api.special.removetra({tra_id: id, special_id: this.search.id}).then(res => {
      //                 if (res.code == 200) {
      //                     this.$Message.success(res.msg);
      //                     // this.tablelist.splice(index, 1);
      //                     this.detail();
      //                 }
      //             });
      //         }
      //
      //     }
      // });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 翻页
    changePage1 () {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.special.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 筛选
    renderTable1: function (name) {
      this.dataloading = true;
      var ps = {
        key: this.search_s.key,
        page: this.pages1.page,
        size: this.pages1.size
      };
      this.$api.tradesman.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.list = res.result.list;
          this.pages1.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    handleSelectRow (selection, index) {
      this.selected = this.$refs.selection.getSelection();
    },
    //选中提交
    ok () {
      console.log(this.tablelist1);
    }
  }
};
</script>
<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
